import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const LoginForm = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth();
  const API_URL = process.env.NODE_ENV === 'development' ? "https://demo.aiguardian.io/agent-backend": "/agent-backend";
  
  const  handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const response = await fetch(API_URL+'/api/login',
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({"username":email,"password":password})
        }
      )  ;

      if (response.ok) {
        let json = await response.json();
        login({
              name:  email,
              email: email,
              role: 'admin',
              token: json.token
            });
        navigate('/tasks/list');     
            console.log(json)      }
      else
        throw new Error('Something went wrong');      

    } catch (error) {
      console.log('There was an error');
      setError("Invalid email or password");
    }   

    // In a real app, you would validate against your backend
    // if (email === 'admin@example.com' && password === 'password') {
    //   login({
    //     name: 'Admin User',
    //     email: email,
    //     role: 'admin'
    //   });
    //   navigate('/tasks/list');
    // } else {
    //   setError('Invalid email or password');
    // }
  };

  return (
    <div className="enhanced-login-form">
      <div className="login-header">
        <div className="login-logo">
          <div className="logo-icon">AD</div>
        </div>
        <h2 className="login-title">Login to Dashboard</h2>
        <p className="login-subtitle">Enter your credentials to access your account</p>
      </div>
      
      {error && (
        <div className="login-error">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
          <span>{error}</span>
        </div>
      )}
      
      <form onSubmit={handleSubmit} className="login-form-content">
        <div className="form-group">
          <label className="form-label" htmlFor="email">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
              <polyline points="22,6 12,13 2,6"></polyline>
            </svg>
            Email Address
          </label>
          <input
            type="text"
            id="email"
            className="form-control"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="admin@example.com"
            required
          />
        </div>
        
        <div className="form-group">
          <label className="form-label" htmlFor="password">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
            </svg>
            Password
          </label>
          <input
            type="password"
            id="password"
            className="form-control"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            required
          />
        </div>
        
        <div className="form-options">
          <label className="checkbox-label">
            <input type="checkbox" /> Remember me
          </label>
          <a href="#" className="forgot-password">Forgot password?</a>
        </div>
        
        <button type="submit" className="login-button">
          Sign In
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
          </svg>
        </button>
      </form>
      
      
    </div>
  );
};

export default LoginForm;